// Máscaras e validações de documentos (BR) — compartilhado por todo o cadastro.
// Criado 01/07 (pedido do usuário): o cadastro de cliente (rápido/completo, PDV ou não)
// só pode aceitar CPF/CNPJ se os dígitos verificadores estiverem CORRETOS.
// A máscara de telefone "(xx) 9xxxx-xxxx" fica em components/TelefoneInput.tsx (formatTelefoneBR).

export function soDigitos(v: string): string {
  return (v || '').replace(/\D/g, '')
}

// Valida CPF pelos 2 dígitos verificadores (algoritmo oficial da Receita).
// Rejeita: tamanho ≠ 11, sequência de dígitos iguais (000..., 111...; passam no DV mas são inválidas),
// ou DV incorreto. NÃO valida CPF vazio aqui — quem chama decide se vazio é permitido.
export function validarCpf(v: string): boolean {
  const c = soDigitos(v)
  if (c.length !== 11) return false
  if (/^(\d)\1{10}$/.test(c)) return false
  let soma = 0
  for (let i = 0; i < 9; i++) soma += parseInt(c[i], 10) * (10 - i)
  let d1 = 11 - (soma % 11)
  if (d1 >= 10) d1 = 0
  if (d1 !== parseInt(c[9], 10)) return false
  soma = 0
  for (let i = 0; i < 10; i++) soma += parseInt(c[i], 10) * (11 - i)
  let d2 = 11 - (soma % 11)
  if (d2 >= 10) d2 = 0
  return d2 === parseInt(c[10], 10)
}

// Valida CNPJ pelos 2 dígitos verificadores (mesma lógica, pesos 2..9 cíclicos).
export function validarCnpj(v: string): boolean {
  const c = soDigitos(v)
  if (c.length !== 14) return false
  if (/^(\d)\1{13}$/.test(c)) return false
  const dv = (base: string): number => {
    let soma = 0
    let peso = base.length - 7
    for (let i = 0; i < base.length; i++) {
      soma += parseInt(base[i], 10) * peso
      peso = peso <= 2 ? 9 : peso - 1
    }
    const r = soma % 11
    return r < 2 ? 0 : 11 - r
  }
  if (dv(c.slice(0, 12)) !== parseInt(c[12], 10)) return false
  return dv(c.slice(0, 13)) === parseInt(c[13], 10)
}

// Valida o documento conforme o tipo de pessoa (PF → CPF, PJ → CNPJ).
export function validarDocumento(doc: string, pessoaTipo: 'PF' | 'PJ' | string): boolean {
  return pessoaTipo === 'PJ' ? validarCnpj(doc) : validarCpf(doc)
}
